
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';


@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})


export class AppChartComponent implements OnInit {

  @Input() data;

  options = {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
        ticks: {
          display: false
        }
      }]
    }
  };



  constructor() {



  }

  ngOnInit() {
    console.log(this.data)
  }

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/chart/chart.component.ts